export default function({
  brandBlue
}) {
  return {
    thickBrandBlue: `5px solid ${brandBlue}`,
  };
}
